// Components
export const COMPONENT_LANDING = 'landing';
export const COMPONENT_ACCESS_CODE = 'codigo de acceso';
// Labels
export const LABEL_INICIA_SESION = 'inicia sesion';
export const LABEL_FORGOT_PASSWORD = 'olvidaste tu contraseña';
export const LABEL_FORGOT_PASSWORD_GET_PASSWORD = 'olvidaste tu contraseña - obtener contraseña';
export const LABEL_FORGOT_PASSWORD_CANCEL = 'olvidaste tu contraseña - cancelar';
export const LABEL_FORGOT_PASSWORD_OK = 'olvidaste tu contraseña - entendido';
export const LABEL_GET_CODE = 'obtener codigo';
export const LABEL_BACK = 'regresar';
export const LABEL_ACCESS_CODE_NEXT = 'codigo de acceso - siguiente';
export const LABEL_ACCESS_CODE_CANCEL = 'codigo de acceso - cancelar';
export const LABEL_ACCESS_CODE_OK = 'codigo de acceso - aceptar';
export const LABEL_OPERADORA_CODE_CANCEL = 'operadora - codigo - cancelar';
export const LABEL_OPERADORA_CODE_OK = 'operadora - codigo - siguiente';
export const LABEL_OPERADORA_RESEND = 'operadora - reenviar codigo';
export const LABEL_MAIL_NEXT = 'correo - siguiente';
export const LABEL_MAIL_INSERT_PASSWORD_NEXT = 'correo - ingresar contraseña - siguiente';
export const LABEL_MAIL_INSERT_PASSWORD_CANCEL = 'correo - ingresar contraseña - cancelar';
export const LABEL_IPTV_NEXT = 'IPTV - siguiente';
export const LABEL_MAIL_CANCEL = 'correo - cancelar';



// WEBPACK FOOTER //
// ./src/authentication/utils/constantsMetrics.ts